import { useState } from 'react';

import styles from './styles.module.scss';

const IntroModal = ({ setShowModal, roomTypes, onStart, t }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const selectOption = (room) => {
    setSelectedOption(room.key);

    // Adobe tracking
    window.lmd = window.globalLmd;
    window.lmd.custom = t(room.title);
    window._satellite.track('CustomInteraction');
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.introModal}>
        <button className={styles.close} onClick={() => setShowModal(false)}>
          <img
            src={`${process.env.PUBLIC_URL}/images_iax/icons/cross.svg`}
            alt='cross'
          />
        </button>
        <h2>{t('tool_ui.intro.modal_title')}</h2>
        <ul>
          {roomTypes.map((room) => (
            <li key={room.key}>
              {t(room.summary)}
              <img
                onClick={() => selectOption(room)}
                alt={selectedOption === room.key ? 'selected' : 'not selected'}
                src={`${process.env.PUBLIC_URL}/images_iax/icons/${
                  selectedOption === room.key ? 'ticked' : 'not-ticked'
                }.svg`}
              />
            </li>
          ))}
        </ul>
        <button
          className={styles.introModal__cta}
          disabled={null === selectedOption}
          onClick={() => onStart('config', selectedOption)}
        >
          {t('tool_ui.button.view_recommended')}
        </button>
      </div>
    </div>
  );
};

export default IntroModal;
